import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ApplicantDetailComponent } from '../applicant.detail.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, formatDate } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS, MAT_LUXON_DATE_FORMATS } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
@Component({
  selector: 'app-applicant-detail-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, FormsModule, CommonModule, MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatSelectModule, MatDividerModule, MatDatepickerModule],
  providers: [
      { provide: DateAdapter, useClass: LuxonDateAdapter, deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS] },
      { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
      { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
  templateUrl: './applicant-detail-dialog.component.html',
  styleUrl: './applicant-detail-dialog.component.scss'
})
export class ApplicantDetailDialogComponent {
terminateApplicationForm: FormGroup;
MAX_COMMENTS_LENGTH = 500;

constructor(private readonly dialogRef: MatDialogRef<ApplicantDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private readonly fb: FormBuilder) {
  this.terminateApplicationForm = this.fb.group({
    terminationDate: ['', [Validators.required] ],
    terminationReason: ['', [Validators.required]],
    comments: ['',Validators.maxLength(500)],
  });
}

onSubmit() {
  this.dialogRef.close({ terminationDate: this.terminateApplicationForm.value.terminationDate.toFormat('MM/dd/yyyy'), terminationReason: this.terminateApplicationForm.value.terminationReason, terminationComments: this.terminateApplicationForm.value.comments });
}
cancel()  {
  this.dialogRef.close(false);
}
}
